<template>
    <main :class="['view', `view--${tools.currentView.key}`]" v-if="tools.currentView">
        <basic-view :tools="tools" viewKey="basic" v-if="showView('basic-view')" />
        <pane-view :tools="tools" viewKey="pane-view" v-if="showView('pane-view')" />
        <orders-view :tools="tools" viewKey="orders-view" v-if="showView('orders-view')" />
        <packages-view :tools="tools" viewKey="packages-view" v-if="showView('packages-view')" />
        <instances-view :tools="tools" viewKey="instances-view" v-if="showView('instances-view')" />
        <items-view :tools="tools" viewKey="items-view" v-if="showView('items-view')" />
        <users-view :tools="tools" viewKey="users-view" v-if="showView('users-view')" />
        <pane-full-view :tools="tools" viewKey="pane-full-view" v-if="showView('pane-full-view')" />
        <show-all-view :tools="tools" viewKey="show-all-view" v-if="showView('show-all-view')" />
        <loans-view :tools="tools" viewKey="loans-view" v-if="showView('loans-view')" />
        <loan-details-view :tools="tools" viewKey="loan-details-view" v-if="showView('loan-details-view')" />
        <fees-view :tools="tools" viewKey="fees-view" v-if="showView('fees-view')" />
        <fee-details-view :tools="tools" viewKey="fee-details-view" v-if="showView('fee-details-view')" />
    </main>
</template>

<script>
    import BasicView from './views/BasicView';
    import PaneView from './views/PaneView';
    import OrdersView from './views/OrdersView';
    import PackagesView from './views/PackagesView';
    import InstancesView from './views/InstancesView';
    import ItemsView from './views/ItemsView';
    import UsersView from './views/UsersView';
    import ShowAllView from './views/ShowAllView';
    import PaneFullView from './views/PaneFullView';
    import LoansView from './views/LoansView';
    import LoanDetailsView from './views/LoanDetailsView';
    import FeesView from './views/FeesView';
    import FeeDetailsView from './views/FeeDetailsView';

    export default {
        name: 'view-container',
        props: ['tools'],
        components: {
            BasicView, PaneView, OrdersView, PackagesView, InstancesView, ItemsView, ShowAllView, PaneFullView, UsersView, LoansView, LoanDetailsView, FeesView, FeeDetailsView,
        },
        methods: {
            showView(key) {
                return this.tools.currentView.key === key;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// ViewContainer.vue?ef932fa0